import React, { Component } from 'react'
import { injectIntl } from 'react-intl'
import { Icon } from 'antd'
import './style.css'
import { IN_PROCESS_STATUS, ERROR_STATUS, EXCEEDS_MAXIMUM_STATUS, CONVERTINATOR_MAX_SIZE_IN_MEGA_BYTES } from '../../../utils/Constants/DocumentConstants'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import { refreshDart } from '../../../actions/CommentAction'

class AssetConvertinatorStatusView extends Component {

  constructor(props) {
    super(props)
    this.state = {
      properMessage: "",
      properIcon: null,
      showRefreshOption: false,
      isRefresing: false

    }
  }

  componentDidMount() {
    this.getMessage()

  }

  refreshPage = () => {
    const { isRefresing } = this.state
    const { refreshDart } = this.props
    if (!isRefresing) {
      this.setState({ isRefresing: true, }, () => refreshDart())
    }
  }


  getMessage = () => {
    const { document: { convertionStatus }, intl } = this.props

    switch (convertionStatus) {
      case IN_PROCESS_STATUS:
        this.setState(
          {
            properMessage: intl.formatMessage({ id: `${IN_PROCESS_STATUS}_message` }),
            properIcon: <Icon type="sync" spin style={{ fontSize: "10vh" }} />,
            showRefreshOption: true
          })
        break;

      case ERROR_STATUS:
        this.setState({
          properMessage: intl.formatMessage({ id: `${ERROR_STATUS}_convertion_message` }),
          properIcon: <Icon type="frown" style={{ fontSize: "10vh" }} />,
          showRefreshOption: false
        })
        break;
      case EXCEEDS_MAXIMUM_STATUS:
        this.setState({
          properMessage: intl.formatMessage({ id: `${EXCEEDS_MAXIMUM_STATUS}_convertion_message` }, { filesize: CONVERTINATOR_MAX_SIZE_IN_MEGA_BYTES }),
          properIcon: <Icon type="meh" style={{ fontSize: "10vh" }} />,
          showRefreshOption: false
        })
        break;

      default:
        this.setState({
          properMessage: intl.formatMessage({ id: `${ERROR_STATUS}_convertion_message` }),
          properIcon: <Icon type="frown" style={{ fontSize: "10vh" }} />,
          showRefreshOption: false
        })
        break;
    }

  }
  render() {

    const { properMessage, properIcon, showRefreshOption } = this.state
    const { intl } = this.props

    return (
      <div className='flex-parent'>
        {properIcon && properIcon}

        <div className='status-message-div'>
          <p className='optimizing-asset'>
            {properMessage}
          </p>
        </div>

        {showRefreshOption && <div className='status-message-div'>
          <p className='refresh-message-style' onClick={this.refreshPage}>
            {intl.formatMessage({ id: "check_asset_available_refresh_message" })}
          </p>
        </div>}
      </div>
    )
  }
}

const mapDispatchToProps = {

  refreshDart
}
export default withRouter(injectIntl(connect(null, mapDispatchToProps)(AssetConvertinatorStatusView)))